module.exports = __webpack_public_path__ + "static/media/404-image.779e4ee3.jpg";